import logo from '../images/iabad-01.png'
const Header = () => {
    return(
        <header>

            <a href="https://www.linkedin.com/in/isiah-abad/" target="_blank" id="logo-container">
                <img src={logo} alt="iabad" id="logoImage" />
            </a>
            
        </header>
       
    )
    
}

Header.defaultProps ={
    title: 'All Star List'
}


export default Header